import { ICON, ICON_VALUE } from '@/constants/icons';

const ALL_DYSFUNCTION_NAME = 'all';

const DYSFUNCTION_NAMES = {
  OXIDATIVE_STRESS: 'oxidativeStress',
  SKIN_APPEARANCE: 'skinAppearance',
  SKIN_REDNESS: 'skinRedness',
  SKIN_DRYNESS: 'skinDryness',
  SKIN_OILINESS: 'skinOiliness',
  SKIN_TEXTURE: 'skinTexture',
  PIMPLES: 'pimples',
  SKIN_PIGMENTATION: 'skinPigmentation'
};

const DYSFUNCTION_LABEL_KEY = {
  [DYSFUNCTION_NAMES.OXIDATIVE_STRESS]: 'section.yourSkin.oxidativeStress.label',
  [DYSFUNCTION_NAMES.SKIN_APPEARANCE]: 'section.yourSkin.skinAppearance.label',
  [DYSFUNCTION_NAMES.SKIN_REDNESS]: 'section.yourSkin.skinRedness.label',
  [DYSFUNCTION_NAMES.SKIN_DRYNESS]: 'section.yourSkin.skinDryness.label',
  [DYSFUNCTION_NAMES.SKIN_OILINESS]: 'section.yourSkin.skinOiliness.label',
  [DYSFUNCTION_NAMES.SKIN_TEXTURE]: 'section.yourSkin.skinTexture.label',
  [DYSFUNCTION_NAMES.PIMPLES]: 'section.yourSkin.pimples.label',
  [DYSFUNCTION_NAMES.SKIN_PIGMENTATION]: 'section.yourSkin.skinPigmentation.label'
};

const DYSFUNCTION_ICONS = {
  [DYSFUNCTION_NAMES.OXIDATIVE_STRESS]: ICON_VALUE[ICON.OXIDATIVE_STRESS],
  [DYSFUNCTION_NAMES.SKIN_APPEARANCE]: ICON_VALUE[ICON.SKIN_APPEARANCE],
  [DYSFUNCTION_NAMES.SKIN_REDNESS]: ICON_VALUE[ICON.SKIN_REDNESS],
  [DYSFUNCTION_NAMES.SKIN_DRYNESS]: ICON_VALUE[ICON.SKIN_DRYNESS],
  [DYSFUNCTION_NAMES.SKIN_OILINESS]: ICON_VALUE[ICON.SKIN_OILINESS],
  [DYSFUNCTION_NAMES.SKIN_TEXTURE]: ICON_VALUE[ICON.SKIN_TEXTURE],
  [DYSFUNCTION_NAMES.PIMPLES]: ICON_VALUE[ICON.PIMPLES],
  [DYSFUNCTION_NAMES.SKIN_PIGMENTATION]: ICON_VALUE[ICON.SKIN_PIGMENTATION]
};

export { ALL_DYSFUNCTION_NAME, DYSFUNCTION_NAMES, DYSFUNCTION_LABEL_KEY, DYSFUNCTION_ICONS };
